import React, { useEffect, useState } from "react";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import ConfirmDeleteModal from "../../Components/ConfirmDeleteModal/ConfirmDeleteModal";
import { MdDelete, MdEdit } from "react-icons/md";
import { IoSend } from "react-icons/io5";
import { FaEye, FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import AddNewClientModal from "../../Components/AddNewClientModal/AddNewClientModal";
import { useDispatch } from "react-redux";
import { deleteClient, getClient, getClientbyid } from "../../Actions/actions";
import { useSelector } from "react-redux";
import Loader from "../../Components/Loader/Loader";
import DropDownCustom from "../../Components/DropDownCustom/DropDownCustom";
import moment from "moment";
import { subscriptionColors } from "../../Reducers/reducers";

const statusColors = {
  paid: "bg-green-200 text-green-700",
  Overdue: "bg-red-200 text-red-700",
  pending: "bg-yellow-200 text-yellow-700",
};

const ClientsManagement = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { loginData, clientsData, loader } = useSelector(
    (state) => state.userReducer
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [edit, setEdit] = useState(false);
  const [isOpenDeleteModal, showDeleteModal] = useState(false);
  const [deleteid, setdeleteid] = useState("");
  const [isAddNewModal, showClientAddModal] = useState(false);

  const filteredClients = clientsData.filter((client) => {
    return (
      client.businessName.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (selectedStatus === "All" ||
        client.paymentStatus.toLowerCase() === selectedStatus.toLowerCase())
    );
  });
  const getClientdata = () => {
    dispatch(getClient(loginData?.accessToken));
  };
  useEffect(() => {
    getClientdata();
  }, []);
  {
    console.log(clientsData, "p");
  }
  const statusOptions = [
    { value: "All", label: "All" },
    { value: "Paid", label: "Paid" },
    { value: "Pending", label: "Pending" },
    { value: "Over Due", label: "Over Due" },
  ];

  const optionSelections = [{ value: "Location", label: "Location" }];
  const handleChanges = (selectedOption, setterFunction) => {
    setterFunction(selectedOption.value);
  };

  return (
    <ParentComponent>
      <PrimaryHeader
        PrivilagesCondition={true}
        buttonText="Add New Client"
        onButtonClick={() => {
          showClientAddModal(true);
          setEdit(false);
        }}
      />
      {loader ? (
        <Loader />
      ) : (
        <>
          <div className="bg-white rounded-t-lg mb-4 flex flex-col md:flex-row items-center md:space-x-6 space-y-4 md:space-y-0">
            <div className="relative w-full md:w-4/6">
              <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#361D32]"
              />
            </div>
            <div className="w-full md:w-2/6 flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
              <DropDownCustom
                isAligned={true}
                selectedValue={statusOptions?.find(
                  (option) => option.value === selectedStatus
                )}
                handleChanges={(option) =>
                  handleChanges(option, setSelectedStatus)
                }
                options={statusOptions}
                isSearchable={false}
                label="Status"
                placeholder="Select Status"
              />

              {/* <DropDownCustom
                isAligned={true}
                selectedValue={optionSelections.find(
                  (option) => option.value === selectOption
                )}
                handleChanges={(option) =>
                  handleChanges(option, setSelectOption)
                }
                options={optionSelections}
                isSearchable={false}
                label="Options"
                placeholder="Select Option"
              /> */}
            </div>
          </div>
          <div className="overflow-x-auto bg-white shadow-md rounded-lg overflow-hidden">
            <table className="min-w-full text-left">
              <thead className="bg-[#361D3214]">
                <tr>
                  <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px]">
                    Client Name
                  </th>
                  <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[120px]">
                    Contact Person
                  </th>
                  <th className="py-4 px-4 text-gray-500 text-center font-semibold text-sm min-w-[200px]">
                    Subscription
                  </th>
                  <th className="py-4 px-4 text-gray-500 text-center font-semibold text-sm min-w-[150px] ">
                    Billing Date
                  </th>
                  <th className="py-4 px-4 text-gray-500 text-center font-semibold text-sm min-w-[100px]">
                    Status
                  </th>
                  <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px] text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredClients?.length > 0 ? (
                  filteredClients?.map((client) => (
                    <tr key={client?.id} className="border-b cursor-pointer">
                      <div
                        className="flex flex-row items-center py-4 px-4 gap-4 min-w-[150px]"
                        onClick={() => {
                          dispatch(
                            getClientbyid(
                              loginData?.accessToken,
                              client?.id,
                              () => {},
                              () => {}
                            )
                          );
                          navigation(
                            `/client-management/details/${client?.businessName}`
                          );
                        }}
                      >
                        <span className="flex w-8 h-8 bg-gray-200 rounded-full items-center justify-center">
                          {client?.logo ? (
                            <img
                              src={client?.logo}
                              className="w-full h-full rounded-full"
                            />
                          ) : (
                            <p className="font-normal text-gray-400 text-lg">
                              {client?.businessName?.slice(0, 1)}
                            </p>
                          )}
                        </span>
                        <td className="font-normal text-gray-800 text-sm text-center">
                          {client?.businessName}
                        </td>
                      </div>
                      <td className="py-4 px-4 min-w-[120px]">
                        <p className="text-gray-800 text-sm font-medium">
                          {client?.contactPersonName}
                        </p>
                        <span className="text-gray-500 text-sm font-normal">
                          {client?.email}
                        </span>
                      </td>
                      <td className="py-4 min-w-[100px] text-center">
                        <span
                          className={`px-3 py-1 rounded-md text-xs font-semibold self-center shadow-sm ${
                            subscriptionColors[client?.subscriptionType]
                          }`}
                        >
                          {client?.subscriptionType}
                        </span>
                      </td>
                      <td className="py-4 text-center text-sm font-normal text-gray-800 min-w-[150px]">
                        <p className="font-medium text-[14px] ">
                          {moment(client?.createdAt).format("DD MMM YY")}
                        </p>
                        <p className="text-[12px]">
                          {moment(client?.createdAt).format("h:mm A")}
                        </p>
                      </td>
                      <td className="py-4 text-center min-w-[100px]">
                        <span
                          className={`px-3 py-1 rounded font-semibold text-xs ${
                            statusColors[client?.paymentStatus]
                          }`}
                        >
                          {client?.subscriptionType === "Free Forever"
                            ? "Free"
                            : client?.paymentStatus === "pending"
                            ? "Pending"
                            : "Paid"}
                        </span>
                      </td>
                      <td className="py-4 justify-center item-center flex gap-3 min-w-[100px]">
                        {/* <button className="text-gray-600 hover:text-gray-900 bg-slate-100 w-8 h-8 flex items-center justify-center rounded-full">
                        <IoSend size={14} />
                      </button> */}
                        <button
                          className="text-gray-600 hover:text-gray-900 bg-slate-100 w-8 h-8 flex items-center justify-center rounded-full"
                          onClick={() => {
                            dispatch(
                              getClientbyid(
                                loginData?.accessToken,
                                client?.id,
                                () => {
                                  setEdit(true);
                                  showClientAddModal(true);
                                },
                                () => {}
                              )
                            );
                          }}
                        >
                          <MdEdit size={18} />
                        </button>
                        <button
                          className="text-gray-600 hover:text-gray-900 bg-slate-100 w-8 h-8 flex items-center justify-center rounded-full"
                          onClick={() => {
                            dispatch(
                              getClientbyid(
                                loginData?.accessToken,
                                client?.id,
                                () => {},
                                () => {}
                              )
                            );
                            navigation(
                              `/client-management/details/${client?.businessName}`
                            );
                          }}
                        >
                          <FaEye size={18} />
                        </button>
                        <button
                          className="text-gray-600 hover:text-gray-900 bg-slate-100 w-8 h-8 flex items-center justify-center rounded-full"
                          onClick={() => {
                            setdeleteid(client?.id);
                            showDeleteModal(true);
                          }}
                        >
                          <MdDelete size={18} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center text-gray-500 py-4">
                      No client found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
      <ConfirmDeleteModal
        isOpen={isOpenDeleteModal}
        onClose={() => {
          showDeleteModal(false);
        }}
        onConfirm={() => {
          dispatch(
            deleteClient(loginData?.accessToken, deleteid, () => {
              getClientdata();
              showDeleteModal(false);
            })
          );
        }}
      />

      <AddNewClientModal
        isOpen={isAddNewModal}
        onClose={() => {
          showClientAddModal(false);
        }}
        onConfirm={() => {
          getClientdata();
        }}
        edit={edit}
      />
    </ParentComponent>
  );
};

export default ClientsManagement;
